// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__9tc6T","app-loader-spin":"style_app-loader-spin__3eAnv"};